import { getEmpresaById } from "@/modules/empresas/firestore";

const FAILURE_THRESHOLD = 0.5; // Se mais de 50% falhar, lança erro

/**
 * Busca dados de empresas a partir de convites
 * @param data - lista de convites
 * @returns - lista de empresas
 * @throws Error se mais de 50% das buscas falharem
 */
async function GetEmpresas(data: TConvite[] | null | undefined): Promise<TEmpresa[]> {
  const empresas: TEmpresa[] = [];

  if (!data || data.length === 0) {
    return [];
  }

  // Filtra IDs válidos
  const validItems = data.filter(
    (item) => item.idEmpresaColaboradorConvidado && item.idEmpresaColaboradorConvidado.trim() !== ""
  );

  if (validItems.length === 0) {
    return [];
  }

  let failedCount = 0;
  const failedIds: string[] = [];

  for (const item of validItems) {
    const empresaId = item.idEmpresaColaboradorConvidado;

    try {
      const newData = await getEmpresaById(empresaId);
      const empresaData = newData.data();

      if (empresaData) {
        empresas.push(empresaData);
      }
    } catch (error) {
      failedCount++;
      failedIds.push(empresaId);
      console.error(`Erro ao buscar empresa ${empresaId}:`, error);
    }
  }

  // Se porcentagem significativa falhou, lança erro
  const failureRate = failedCount / validItems.length;
  if (failureRate >= FAILURE_THRESHOLD) {
    throw new Error(
      `Falha ao carregar ${failedCount} de ${validItems.length} empresas (${Math.round(failureRate * 100)}%). ` +
        `IDs com falha: ${failedIds.slice(0, 5).join(", ")}${failedIds.length > 5 ? "..." : ""}`
    );
  }

  // Se algumas falharam mas abaixo do limiar, loga warning
  if (failedCount > 0) {
    console.warn(
      `Aviso: ${failedCount} de ${validItems.length} empresas não puderam ser carregadas. ` +
        `Dados podem estar incompletos.`
    );
  }

  return empresas;
}

export default GetEmpresas;
